<template>
    <div>
        <Headers :title="title"></Headers>
        <van-row style="padding:0 .28rem 0 .28rem">
            <van-col  class="card-wrap"  v-for="(item, index) in cardList" :key="index" span="8">
                <template>
                    <h2 class="h2" :title="item.card.holder_info.name">
                        <img :src="item.card.holder_info.logo_url || require('@/assets/user/lt.png')" alt="" />
                        <p>{{ item.card.holder_info.name }}</p>
                    </h2>
                    <div class="line"></div>
                    <p class="name" :title="item.card.holder_info.manager_name">{{  item.card.holder_info.manager_name }}</p>
                    <p class="items" style="margin-top: .3rem">
                        <img src="../../../assets/user/email.png" class="email-icon" alt="" />
                        <span class="item" :title="item.card.holder_info.email">
                            {{ userCenter.email + item.card.holder_info.email || "" }}
                        </span>
                    </p>
                    <p class="items">
                        <img src="../../../assets/user/address.png" class="address-icon" alt="" />
                        <span class="item" :title="item.card.holder_info.address">{{ userCenter.address + item.card.holder_info.address || "" }}</span>
                    </p>
                    <p class="items">
                        <img src="../../../assets/user/exhibit.png" class="exhibit-icon" alt="" />
                        <span class="item" :title="item.exhibition.base_info.data.cn.name">{{
                            userCenter.exhibition + item.exhibition.base_info.data.cn.name || ""
                        }}</span>
                    </p>
                </template>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import api from "@/api";
import { mapState } from "vuex";

export default {
    data(){
        return{
            cardList:[],
        }
    },
    created () {
      this.getCardList()
    },
    components: {
        Headers
    },
    methods: {
        getCardList() {
            api.getCardList({  }).then((res) => {
                if (res.res == 1) {
                    this.cardList = res.cards || [];
                    this.noData = !this.cardList.length;
                }
            });
        }
    },
    computed: {
        userCenter() {
            return this.$t("userCenter");
        },
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  '名片夹' : 'Business card holder'
        },
        ...mapState(["userInfo","language"]),
    }
}
</script>

<style lang="scss" scoped>
.card-wrap{
    &:nth-child(1){
        margin-top: .3rem;
    }
    &:nth-last-child(){
        margin-bottom: .3rem;
    }
    width: 6.9rem;
    height: 4.1rem;
    margin-bottom: .48rem;
    background: #fff;
    box-shadow: 0px 6px 17px 0px rgba(34, 38, 56, 0.2);
    border-radius: 7px;
    padding: .3rem;
    .h2{
        // width: 6.9rem;
        height: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #09468c;
        img{
            max-width: 100%;
            max-height: .8rem;
            object-fit: contain;
            padding: .08rem;
            margin-right: .1rem;
        }
        p{
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            height: .8rem;
            line-height: .8rem;
            font-size: 14px
        }
    }
    .line {
        width: 100%;
        height: .02rem;
        background-color: rgba(0, 0, 0, 0.09);
    }
    .name{
        margin-top: .14rem;
        font-weight: 500;
       color: #09468c;
        font-size: 18px;
        margin-bottom: .14rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .items{
        display: flex;
        align-items: center;
        margin-bottom: .3rem;
        color: #5f7185;
        img{
            width: .3rem;
            height: .3rem;
            margin-right: .1rem;
        }
        .item{
            font-size: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
} 
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobilePersonalCenter/cardHolder.vue